<template>
  <span class="count-of text-nowrap">{{
    t("dashboard.portfolio.table.count_cell.of", {
      count: formatNumberWithSpaces(count),
    })
  }}</span>
</template>

<script setup lang="ts">
import { formatNumberWithSpaces } from "@/composables/formatUtils";
import { useI18n } from "vue-i18n";

/** The small "of {count}" line under a Count cell amount that is less than the whole row. */
defineProps<{
  /** The row's whole amount, in MWh. */
  count: number;
}>();

const { t } = useI18n();
</script>

<style scoped lang="scss">
.count-of {
  font-size: 0.6875rem;
  line-height: 1.1;
}
</style>
